import { render, staticRenderFns } from "./MonetaryActionSelectBox.vue?vue&type=template&id=35650bf2&scoped=true&"
import script from "./MonetaryActionSelectBox.vue?vue&type=script&lang=js&"
export * from "./MonetaryActionSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35650bf2",
  null
  
)

export default component.exports